module.exports = "img.default-style {\n  width: 100%;\n  height: auto; }\n\nimg.defined-width {\n  width: 6ch;\n  height: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/images/image.component.scss
// module id = ./src/app/shared/components/images/image.component.scss
// module chunks = main